<template>
  <div class="order-event-container">
    <div class="margin-top">
      <el-table :data="aOrderDetailEventInfo.events" border style="width: 100%" v-loading="loading">
        <el-table-column type="index" :label="$t('aOrderDetailEvent.serial')" align="center" width="80">
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('aOrderDetailEvent.operationTime')" align="center" width="180">
        </el-table-column>
        <el-table-column prop="eventMsg" :label="$t('aOrderDetailEvent.description')" align="center" min-width="300">
        </el-table-column>
      </el-table>

      <el-row class="margin-top">
        <el-col :span="24" class="text-right">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="pagination.currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pagination.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
          </el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getOrderEvents } from '@/api/order/aOrderDetailApi'

export default {
  name: 'AOrderDetailEvent',
  data() {
    return {
      aOrderDetailEventInfo: {
        events: [],
        orderId: '',
        prodNameLike: '',
        personNameLike: ''
      },
      loading: false,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  methods: {
    open(params) {
      this.aOrderDetailEventInfo.orderId = params.orderId
      this.loadOrderEventData()
    },
    loadOrderEventData() {
      this.loading = true
      const params = {
        orderId: this.aOrderDetailEventInfo.orderId,
        page: this.pagination.currentPage,
        row: this.pagination.pageSize
      }

      getOrderEvents(params).then(response => {
        this.aOrderDetailEventInfo.events = response.data
        this.pagination.total = response.records
        this.loading = false
      }).catch(error => {
        console.error('获取操作信息失败:', error)
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadOrderEventData()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.loadOrderEventData()
    }
  }
}
</script>

<style scoped>
.order-event-container {
  padding: 15px;
}

.margin-top {
  margin-top: 15px;
}

.text-right {
  text-align: right;
}
</style>